// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Iuoz","newExpiryDate":"styles_newExpiryDate__1Y5D1","footer":"styles_footer__7Q78L"};